import React from 'react';
// import App from '../App'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import OidCheck from '../../pages/OidCheck';
import tns from '../../pages/TNS';
import CollectionsDetail from '../../pages/CollectionsDetail';
import add from '../../pages/Package/add';

const Routes = (props: any) => {
    return (
        <Switch>
            <Route path="/statistics/tns" component={tns}/>
            <Route path="/statistics/oid-check" component={OidCheck}/>
        </Switch>
  )
}
export default Routes
